import { useState } from 'react'
import { webPushStatus, registerWebPush } from '../pushNotifications'

// Kaartje op Home voor leden op Android (TWA) en de website: vraagt met één
// tik toestemming voor meldingen. Op iPhone (native app) toont dit niets;
// daar regelt pushNotifications.js het zelf.
const LATER_KEY = 'vs-meldingen-later'

function laterGekozen() {
  try { return localStorage.getItem(LATER_KEY) === '1' } catch { return false }
}

export default function MeldingenKaart({ lidId }) {
  const [status, setStatus] = useState(webPushStatus)
  const [verborgen, setVerborgen] = useState(laterGekozen)
  const [bezig, setBezig] = useState(false)
  const [fout, setFout] = useState('')

  if (verborgen || status === 'unsupported' || status === 'granted') return null

  async function zetAan() {
    setBezig(true)
    setFout('')
    try {
      const gelukt = await registerWebPush(lidId, { vraagToestemming: true })
      setStatus(webPushStatus())
      if (!gelukt && Notification.permission === 'granted') {
        setFout('Aanzetten is niet gelukt. Probeer het later nog eens.')
      }
    } catch (e) {
      console.error('Meldingen aanzetten mislukt:', e)
      setFout('Aanzetten is niet gelukt. Probeer het later nog eens.')
    } finally {
      setBezig(false)
    }
  }

  function later() {
    try { localStorage.setItem(LATER_KEY, '1') } catch { /* geen opslag: alleen nu verbergen */ }
    setVerborgen(true)
  }

  return (
    <div className="card" style={{ marginBottom: 4 }}>
      <p style={{ fontFamily: 'Montserrat', fontSize: 13, fontWeight: 700, margin: '0 0 6px', color: 'var(--text)' }}>
        🔔 Meldingen
      </p>
      {status === 'denied' ? (
        <p style={{ fontSize: 12, color: 'var(--muted)', margin: 0 }}>
          Meldingen staan uit. Zet ze aan via de instellingen van je telefoon
          (Apps → Vitaal Sterk → Meldingen) om berichten van de balie te ontvangen.
        </p>
      ) : (
        <>
          <p style={{ fontSize: 12, color: 'var(--muted)', margin: '0 0 12px' }}>
            Krijg een melding als de balie je een bericht stuurt.
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={zetAan}
              disabled={bezig}
              style={{ background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 20, padding: '9px 20px', fontSize: 13, fontWeight: 700, fontFamily: 'Montserrat', cursor: 'pointer' }}
            >
              {bezig ? 'Even geduld…' : 'Meldingen aanzetten'}
            </button>
            <button
              onClick={later}
              style={{ background: 'none', color: 'var(--muted)', border: 'none', fontSize: 13, cursor: 'pointer' }}
            >
              Later
            </button>
          </div>
          {fout && <p style={{ fontSize: 12, color: 'var(--red)', margin: '8px 0 0' }}>{fout}</p>}
        </>
      )}
      {status === 'denied' && (
        <button onClick={later} style={{ background: 'none', color: 'var(--muted)', border: 'none', fontSize: 12, cursor: 'pointer', padding: '8px 0 0' }}>
          Verbergen
        </button>
      )}
    </div>
  )
}
